import { Fehler, PollingResponseModel } from '@ps20/bff-models';
import { GlobalActions, GlobalPut, ModalType } from '@ps20-frontend/shop-integration-redux';
import { call, take } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import { CallEffect, TakeEffect } from '@redux-saga/core/effects';
import { AxiosError } from 'axios';
import { CheckoutAction } from '../../checkout.actions';
import {
  getValidationMessage,
  PollingErrorResponseModel,
  splitValidationMessage,
} from './pollingHelper';

function* showErrorModal(
  errorAction: CheckoutAction<PollingResponseModel<unknown>>,
  globalPut: GlobalPut,
): Generator<CallEffect> {
  if (errorAction.payload?.response === Fehler.AV_EINREICHEN_TECHID_VERGEBEN) {
    return yield call(
      globalPut.put,
      new GlobalActions().requestModal(ModalType.ANTRAG_EINREICHEN_TECHID_ERROR),
    );
  }
  return yield call(
    globalPut.put,
    new GlobalActions().requestModal(ModalType.ANTRAG_EINREICHEN_ERROR),
  );
}

function* showErrorModalForValidation(
  errorAction: CheckoutAction<PollingResponseModel<PollingErrorResponseModel>>,
  globalPut: GlobalPut,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  if (
    errorAction.payload instanceof AxiosError &&
    errorAction.payload.response?.data?.additionalInformation
  ) {
    return yield call(
      globalPut.put,
      new GlobalActions().requestModal(ModalType.VALIDATION_ERROR, {
        body: splitValidationMessage(errorAction.payload.response.data.additionalInformation),
        button: 'Schließen und zurück zum Shop',
      }),
    );
  }
  return yield call(
    globalPut.put,
    new GlobalActions().requestModal(ModalType.VALIDATION_ERROR, {
      body: getValidationMessage(errorAction),
      button: 'Schließen und zurück zum Shop',
    }),
  );
}

export function* handlePollingError(
  errorAction: CheckoutAction<PollingResponseModel<PollingErrorResponseModel>>,
): Generator<CallEffect | TakeEffect> {
  const globalPut = GlobalPut.getInstance();
  if (
    errorAction?.payload?.response?.data?.status === 400 ||
    (errorAction.payload instanceof AxiosError && errorAction.payload.response?.status === 400)
  ) {
    yield call(showErrorModalForValidation, errorAction, globalPut);
  } else {
    yield call(showErrorModal, errorAction, globalPut);
  }

  yield take(GlobalActions.CLOSE_MODAL);
  yield call(globalPut.put, new GlobalActions().navigationRequested({ appId: App.SHOP_DASHBOARD }));
}
